<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>Blogs</li>
                <li></li>
            </ul>
            <h2 i18n>List of Blogs</h2>
        </div>
    </div>
</div>

<div class="blog-area ptb-100" [class.dark-blog-area]="themeService.isDark()">
    <div class="container">
        <div class="row pb-5">
            <h3 i18n>All Blogs</h3>
            <div class="woocommerce-topbar">
                <div class="row align-items-center">
                    <div class="col-lg-12 col-md-12">
                        <div class="topbar-ordering-and-search">
                            <div class="row align-items-center">
                                <form [formGroup]="filter_form" (submit)="applyFilter()">
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12">
                                            <div class="billing-details">
                                                <div class="row">
                                                    
                                                    
                                                    <div class="col-lg-6 col-md-6 pt-3">
                                                        <div class="form-group">
                                                            <label i18n>Title</label>
                                                            <input type="text" formControlName="title"
                                                                class="form-control">

                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6 col-md-6 pt-3">
                                                        <div class="form-group">
                                                            <label i18n>Author</label>
                                                            <input type="text" formControlName="author"
                                                                class="form-control">

                                                        </div>
                                                    </div>

                                                    <div class="col-lg-6 col-md-6">
                                                        &nbsp;
                                                        <div class="form-group">
                                                            <label i18n>Language</label>
                                                            <div class="select-box">
                                                                <select formControlName="content_language"
                                                                    class="form-select">
                                                                    <option *ngFor="let lang of languages"
                                                                        [value]="lang.id">{{lang.value}}</option>

                                                                </select>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6 pt-3">
                                                        <div class="form-group">
                                                            <label>&nbsp;<span></span></label>
                                                            <button type="submit" value="Filter" class="default-btn">
                                                                <i class='bx bx-filter-alt icon-arrow before'></i><span
                                                                    class="label" i18n>Filter</span><i
                                                                    class="bx bx-filter-alt icon-arrow after"></i>
                                                            </button>
                                                            &nbsp; &nbsp;
                                                            <a (click)="resetFilter()" class="back-btn">
                                                                <i class='bx bx-reset icon-arrow before'></i><span
                                                                    class="label" i18n>Reset</span><i
                                                                    class="bx bx-reset icon-arrow after"></i>
                                                            </a>
                                                        </div>

                                                    </div>


                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let blog of blogs">
                <div class="single-blog-post mb-30">
                    <div class="post-image">
                        <a routerLink="/blogs/{{blog.id}}" class="d-block">
                            <img [src]="imageUrl + blog.images[0].url" style="height:20em" alt="image">
                        </a>
                        
                    </div>
                    <div class="post-content">
                        <ul class="post-meta">
                            <li class="post-author">
                                <span i18n>By: </span><a class="d-inline-block">{{blog.author}}</a>
                            </li>
                            <li><a>{{blog.created_at| date :'longDate'}}</a></li>
                        </ul>
                        <h3><a routerLink="/blogs/{{blog.id}}" class="d-inline-block">{{blog.title}}</a></h3>
                        <a routerLink="/blogs/{{blog.id}}" class="read-more-btn" i18n>Read More <i
                                class='bx bx-right-arrow-alt'></i></a>
                    </div>
                </div>
            </div>


            <div class="col-lg-12 col-md-12 col-sm-12">
                <app-pagination [currentPage]="currentPage" [itemsPerPage]="itemsPerPage" [totalItems]="totalItems"
                    (pageChanged)="onPageChange($event)"></app-pagination>
            </div>
        </div>
    </div>
</div>